<template>
    <div class="main-content" id="panel">
        <div class="header bg-primary pb-6">
            <div class="container-fluid">
            <div class="header-body">
                <div class="row align-items-center py-4">
                    <div class="col-lg-8 col-6">
                    <h2>Failed Notifications</h2>
                    </div>
                    <div class="col-lg-4 col-6 text-right bid">
                    <!-- <button  type="button" class="btn btn-success"><i class="fas fa-user-plus"></i> ADD NEW CUSTOMER</button>
                    <button type="button" class="btn btn-info"><i class="fas fa-file"></i> IMPORT DATA</button> -->
                    <form @submit.prevent="" class="form-inline d-flex justify-content-center md-form form-sm mt-0">
                        <i @click="searchLog()"  class="fas fa-search active cursor-pointer" aria-hidden="true"></i>
                        <input v-on:keyup.enter="searchLog" v-model.trim="searchValue"  @keypress="isAlphanumeric($event)" class="form-control form-control-sm ml-3 w-75" type="text" placeholder="Search" aria-label="Search">
                        <i v-if="searchValue" @click="clearSearch()" class="fas fa-times-circle cursor-pointer"></i>
                        </form>              
                    </div>
                </div>
                
            </div>
            </div>
        </div>
        <!-- <div class="container-fluid mt--6 filter-show">
            <div class="card w-100 p-2 mb-2  d-inline-block">
                <div class="d-flex justify-content-between">
                    <h5 class="ml-3">Filters</h5>
                    <span class="btn btn-link" @click="showFilters = !showFilters">
                    <i class="fa" v-bind:class="[showFilters ? 'fa-angle-up' : 'fa-angle-down']" ></i> {{showFilters ? 'Hide' : 'Show'}} Filters
                    </span>
                </div>
                <div class="row" v-if="showFilters">
                    <div class="col-lg-12">
                        <form class="row">
                        <div class="col-md-6 col-lg-3">
                            <label for="filter" class="col-form-label">Status</label>
                             <multiselect 
                                v-model="newStatus" 
                                placeholder="Status" 
                                label="name" 
                                track-by="value" 
                                :options="statusList" 
                                :multiple="false" 
                        
                                :limit="4"  >
                                <template slot="option" slot-scope="{ option }">
                                    <span :title="option.description">{{ option.name }}</span>
                                </template>
                            </multiselect>
                        </div>
                        <div class="col-md-6 col-lg-3">
                            <label for="filter" class="col-form-label">User</label>
                             <multiselect 
                                @input="changeUser"
                                v-model="filterUser" 
                                placeholder="Select user" 
                                label="firstName" 
                                track-by="id"
                                :options="userList"  
                                :limit="3"  ></multiselect>
                        </div>
                        <div class="col-md-4 col-lg-2">
                            <div class="form-check mt-5">
                                <input  @change="changeIsNoUser()" id="checkbox2" type="checkbox"  class="form-check-input wh" v-model="isNoUserLog" >
                                <label for="checkbox2" class="form-check-label">No User Log</label>
                            </div>
                        </div>
                        <div class="col-md-6 col-lg-3">
                            <button @click="clearFilter()" type="button" class="btn btn-secondary rounded top-2">Clear</button>
                            <button  @click="filelogs()" type="button" class="btn btn-primary rounded top-2">Filter</button>
                        </div>
                        </form>
                    </div>
                </div>
            </div>
        </div> -->
        <div class="container-fluid mt--6 " >
            <div class="row">
                 <div class="col-xl-12">
                    <div class="card vh-75" id="scroll">
                        <div class="table-responsive">
                        <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                        <table class="table invt align-items-center table-flush table-hover bidtbl bid-acc">
                            <thead class="thead-light psticky">
                            <tr>
                               <th 
                                    scope="col" 
                                    class="sort"
                                     >Message</th>
                                <th 
                                    scope="col" 
                                    class="sort"
                                    >Date</th>      
                            </tr>
                            </thead>
                            <tbody class="list">
                            <tr v-if="logs.length == 0 && !loading">
                                <td><p class="nodata">No data available</p>
                                </td>
                            </tr>
                            <tr v-for="data in logs" :key="data.id">
                                <td>{{data.message}}</td>
                                <td>{{moment(data.createdDate).format("MMMM DD YYYY, h:mm:ss a")}}</td>
                                
                            </tr>
                            </tbody>
                        </table>
                        <nav aria-label="Page navigation example" v-if="!(logs.length == 0 && currentPage === 0)">
                            <ul class="pagination justify-content-center">
                                <li class="page-item" v-bind:class="{ disabled: currentPage === 0 }">
                                    <a class="page-link cursor-pointer"   @click="previous()">
                                        <i class="fa fa-angle-left"></i>
                                        <span class="sr-only">Previous</span>
                                    </a>
                                </li>
                                <li class="page-item active"><a class="page-link">{{currentPage+1}}</a></li>
                                <li class="page-item" v-bind:class="{ disabled: this.logs.length < this.perPage }"  >
                                    <a class="page-link cursor-pointer" @click="next()">
                                        <i class="fa fa-angle-right"></i>
                                        <span class="sr-only">Next</span>
                                    </a>
                                </li>
                            </ul>
                        </nav>
                        <!-- Pagination-->
                        <!-- <b-pagination
                            class="mt-4"
                            :total-rows="totalRows"
                            v-model="currentPage"
                            :per-page="perPage"
                            @input="filelogs(currentPage)"
                        ></b-pagination>
                        <div class="total-records">
                            <span>Total Records : {{totalRows}}</span>
                        </div> -->
                        </div>
                    </div>
                    </div>
            </div>
        </div>
    </div>      
</template>
<script>
import config from "@/config";
import authService from "@/authService";
export default {
  name: "imsCusipComponent",
  data() {
    return {
        accessToken:null,
        loading : false,
        currentPage: 0,
        perPage: 25,
        searchValue : "",
        totalRows : 0,
        sortColumn: "",
        sortOrder: "ASC",
        logs : [],
        showFilters : false,
        statusList :  [
                       { name: 'Send to ecn', value: 'ECN_SENT',description :'' },
                       { name: 'Received', value: 'BID_RECEIVED',description :'' },
                       { name: 'Accepted', value: 'BID_ACCEPTED',description :''},
                       { name: 'Waiting Auth', value: 'WAITING_AUTHORIZATION',description :''},
                       { name: 'Authorized', value: 'AUTHORIZED',description :''},
                       { name: 'Rejected', value: 'REJECTED',description :''},
                       { name: 'New Order Initiated', value: 'NEW_ORDER_INITIATED',description :''},
                       { name: 'Bid Cancelled', value: 'AUTHORIZED_BID_CANCELLED',description :''}

                       ],
        prevStatus : null,
        newStatus : null,
        userList : [],
        filterUser : null,
        isNoUserLog : false


     
    };
  },
  methods: {
    changeIsNoUser(){
        if(this.isNoUserLog) this.filterUser = null;
    },
    changeUser(){
        if(this.filterUser) this.isNoUserLog = false;
    },
    clearFilter(){
        this.prevStatus  = null;
        this.newStatus  = null;
        this.filterUser = null;
        this.isNoUserLog = false;
        this.filelogs();
    },
    searchLog(){
        this.currentPage = 0;
        this.filelogs();  
    },
    
    clearSearch(){
        this.searchValue = "";
        this.currentPage = 0;
        this.filelogs();  
    },
    next(){
        if(this.logs.length === this.perPage){
            this.currentPage++;
            this.filelogs(); 
        }
        
    },
    previous(){
        if(this.currentPage > 0){
            this.currentPage--;
            this.filelogs(); 
        }
        
    },
    filelogs(){
      this.loading = true;
      const auth = {
        headers: {'org-token' : authService.getOrgToken() }
      };
    // let prevStatus = this.prevStatus.length == 0  ? this.statusList.map((e) => {return e.value}).toString() : this.prevStatus.map((e) => {return e.value}).toString();
    //   let congnitoSub = "";
    //   if(this.filterUser){
    //     congnitoSub = "&cognitoSub="+this.filterUser.cognitoSub;
    //   }
    //   if(this.isNoUserLog){
    //     congnitoSub = "&cognitoSub=";
    //   }
      this.$http
        .get(
          config.baseUrlAutoBidder + "/logs/failures"+
          "?offset="+this.currentPage+
          "&limit="+this.perPage+
          "&type=BID_REJECT",
        //  "&searchText="+this.searchValue+
        //   "&previousStatus="+(this.prevStatus ? this.prevStatus.value : "")+
        //   "&newStatus="+(this.newStatus ? this.newStatus.value : "")+
        //   congnitoSub,
          auth
        )
        .then((result) => {
            this.logs = result.data;
            this.loading = false;

        })
        .catch(e => {
          console.log(e);
          this.loading = false;
        });
    },
    getUserList(){
      this.loading = true;
      const auth = {
        headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
           config.baseUrlBidSide +
            "/user/list?page=1&size=1000&search=&status=&sortColumn=firstName&sortOrder=ASC&group=",
            auth
        )
        .then(result => {
          // this.userList = result.data.content.filter((e) => {return e.traderId != null});
          result.data.content.forEach(trader =>{
            trader.firstName =  trader.firstName+" "+trader.lastName;
          });
          this.userList = result.data.content;
          this.loading = false;
        })
        .catch(e => {
          console.log(e);
        });
    },
   
  },
  mounted() {
    this.getUserList()
    this.filelogs()
  }
};
</script>